import CloseChatBubble from '../../../assets/closeChatBubble.svg';

const CloseChatBubbleIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <CloseChatBubble data-testid="close-chat-bubble-icon" {...props} />;
};

export default CloseChatBubbleIcon;
